import { Link } from '@/global/components/Link'
import { cn } from '@/lib/utils'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const CAPTCHA_SITE_KEY = import.meta.env.VITE_CAPTCHA_SITE_KEY

interface CaptchaProviderProps {
    children: React.ReactNode
}

/**
 * Provider do Captcha - deve envolver apenas os componentes que precisam de captcha
 */
export default function CaptchaProvider({ children }: CaptchaProviderProps) {
    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={CAPTCHA_SITE_KEY}
            language="pt-BR"
            scriptProps={{
                async: true,
                defer: true,
            }}
        >
            {children}
        </GoogleReCaptchaProvider>
    )
}

export function CaptchaNotice({
    className,
    ...props
}: React.HTMLAttributes<HTMLSpanElement>) {
    return (
        <span
            className={cn('text-xs text-muted-foreground', className)}
            {...props}
        >
            Este site é protegido pelo reCAPTCHA e a{' '}
            <Link
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
            >
                Política de Privacidade
            </Link>{' '}
            e os{' '}
            <Link
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
            >
                Termos de Serviço
            </Link>{' '}
            do Google se aplicam.
        </span>
    )
}
